import { IconAlertTriangle, IconCheck } from 'featherico';
import { get } from 'lodash/fp';
import PropTypes from 'prop-types';
import { Component, Fragment, createElement } from 'react';
import { withAppContext } from '../../hoc/withAppContext';
import Button from '../Button';
import { DeprecatedButtonContainer } from '../ButtonContainer';
import TextArea from '../TextArea';
import { postError } from './service';

const REQUEST_STATUS = {
    INIT: 'init',
    PENDING: 'pending',
    SUCCEEDED: 'succeeded',
    FAILED: 'failed',
};

class ApiError extends Component {
    constructor(props) {
        super(props);
        this.state = {
            formVisible: false,
            formValue: '',
            requestStatus: REQUEST_STATUS.INIT,
        };

        this.sendSupportRequest = this.sendSupportRequest.bind(this);
    }

    sendSupportRequest(error, userId, userText) {
        this.setState({ requestStatus: REQUEST_STATUS.PENDING });
        postError({ error, userId, userText }).then(
            () => this.setState({ requestStatus: REQUEST_STATUS.SUCCEEDED }),
            () => this.setState({ requestStatus: REQUEST_STATUS.FAILED })
        );
    }

    render() {
        const { icon, title, body, hasBugReportLink } = getModel(this.state.requestStatus);
        const userId = get('user.id')(this.props.appContext);
        return (
            <div className="api_error">
                <h2>
                    {!icon ? (
                        <img className="api_error-icon--bot" src="/images/si-bot-warning.svg" alt="" />
                    ) : (
                        createElement(icon)
                    )}
                    {title}
                </h2>
                <p>
                    {createElement(body)}
                    {hasBugReportLink ? (
                        <ApiErrorBugReportLink
                            onClick={() => this.setState({ formVisible: !this.state.formVisible })}
                            isFormVisible={this.state.formVisible}
                        />
                    ) : (
                        ''
                    )}
                </p>
                {hasBugReportLink && this.state.formVisible ? (
                    <ApiErrorBugReportForm
                        value={this.state.formValue}
                        onChange={e => this.setState({ formValue: e.target.value })}
                        onClickSubmit={() => this.sendSupportRequest(this.props.error, userId, this.state.formValue)}
                    />
                ) : (
                    ''
                )}
            </div>
        );
    }
}

function getModel(requestStatus) {
    switch (requestStatus) {
        case REQUEST_STATUS.SUCCEEDED:
            return {
                icon: () => <IconCheck className="api_error-icon api_error-icon--check" />,
                title: 'Thank You!',
                body: () => (
                    <Fragment>
                        We have received your bug report and will investigate the bug as soon as possible. For now, you
                        could try to refresh your browser and try again.
                    </Fragment>
                ),
                hasBugReportLink: false,
            };
        case REQUEST_STATUS.FAILED:
            return {
                icon: () => <IconAlertTriangle className="api_error-icon api_error-icon--warning-sign" />,
                title: 'Sorry',
                body: () => (
                    <Fragment>
                        We could not send your report, please reach out to us directly via{' '}
                        <a href="mailto:support@small-improvements.com">support@small-improvements.com</a>.
                    </Fragment>
                ),
                hasBugReportLink: false,
            };
        case REQUEST_STATUS.INIT:
        case REQUEST_STATUS.PENDING:
        default:
            return {
                title: 'Something went wrong',
                body: () => (
                    <Fragment>
                        Your last action couldn't be performed. Please make a copy of unsaved content, reload the page
                        and try again.
                    </Fragment>
                ),
                hasBugReportLink: false,
            };
    }
}

function ApiErrorBugReportLink({ onClick, isFormVisible }) {
    return (
        <Fragment>
            &nbsp;If the error persists you can{' '}
            {isFormVisible ? (
                <Fragment>send a bug report.</Fragment>
            ) : (
                <Fragment>
                    <Button kind="LINK" onClick={onClick}>
                        send a bug report
                    </Button>
                    .
                </Fragment>
            )}{' '}
            We apologize for the inconvenience.
        </Fragment>
    );
}

function ApiErrorBugReportForm({ value, onChange, onClickSubmit }) {
    const textareaProps = {
        placeholder: 'E.g. I was trying to add a new user, and as I pressed the Add User button this error popped up.',
        rows: 5,
        value,
        onChange,
    };

    return (
        <div>
            <h3>Please describe what you did</h3>
            <TextArea {...textareaProps} />
            <DeprecatedButtonContainer>
                <Button kind="PRIMARY" onClick={onClickSubmit}>
                    Send bug report
                </Button>
            </DeprecatedButtonContainer>
        </div>
    );
}

ApiError.propTypes = {
    // we expect error to look like axios response object
    error: PropTypes.shape({
        data: PropTypes.object,
        status: PropTypes.number,
        statusText: PropTypes.string,
        config: PropTypes.object,
    }).isRequired,
};

export default withAppContext(ApiError);
